import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import FeaturedCard from '../FeaturedCard';
import SectionTitle from '../reusables/SectionTitle';

const Container = styled.div({ marginBottom: 50 });
const ButtonContainer = styled.div({
  marginTop: 0,
  fontSize: 14,
  textDecoration: 'underline',
});

function FeaturedContent({ items }) {
  return (
    <Container>
      <SectionTitle>BETEENDEBLOGGEN & NYHETER</SectionTitle>
      {items?.map((node) => {
        const isProject = node.__typename === 'ContentfulCase';
        return (
          <FeaturedCard
            key={node.id}
            title={node.title}
            image={isProject ? node.heroImage : node.image}
            eyebrow={isProject ? 'Projekt' : node.category.title}
            to={
              isProject
                ? `/cases/${node.slug}`
                : `/${node.category.slug}/${node.slug}`
            }
          />
        );
      })}
      <ButtonContainer>
        <Link to="/latest">Fler blogginlägg och nyheter</Link>
      </ButtonContainer>
    </Container>
  );
}

export default FeaturedContent;
